import { ABSOLUTE_ROOT_PATH } from '../../constants';
import { SeoMetaTags } from '../../../shared/types';

export const calculateArticleLink = ({ seo }: { seo: SeoMetaTags }) => seo.pageUrl.split('fiverr.com')[1];

export const calculateCategoryLink = ({ handle }: { handle: string }) =>
    `${ABSOLUTE_ROOT_PATH}/${handle.split('/')[1]}`;

export const prefixFields = (fields: string[], prefix: string) => fields.map((field) => `${prefix}.${field}`).join(',');
